import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowGrey",
  "use": "ArrowGrey-usage",
  "viewBox": "0 0 182.13 181.53",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 182.13 181.53\" id=\"ArrowGrey\"><path fill=\"#3c4859\" d=\"M90.76 181.53l90.77-90.76L90.76 0 74.44 16.33l62.89 62.89H0v23.09h137.33l-62.89 62.9 16.32 16.32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol